// extracted by mini-css-extract-plugin
export default {"loader":"loaders_loader__XlisI","loader-wave":"loaders_loader-wave__jOSAe"};